export default __webpack_public_path__ + "static/media/navbar-icon-direct-sales.8925a809.svg";